import { Link } from "react-router-dom";

/**
 * Página 404 — estilo "ai automation".
 * Requiere react-router-dom v6+.
 * Ajusta las rutas de los botones ("/" y "/soporte") a las de tu app.
 */
export function NotFoundPage() {
    return (
        <div style={styles.page}>
            <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-12px); }
        }
      `}</style>
            <div style={styles.scene}>
                {/* ---- Robot ---- */}
                <div style={styles.robotWrap}>
                    <svg viewBox="0 0 260 320" width="260" height="320" style={styles.robot}>
                        <ellipse cx="130" cy="300" rx="70" ry="14" fill="#1c0f3d" opacity="0.35" />
                        <line x1="130" y1="18" x2="130" y2="46" stroke="#e7e2fb" strokeWidth="4" />
                        <circle cx="130" cy="14" r="7" fill="#e7e2fb" />
                        <rect x="40" y="48" rx="34" ry="34" width="180" height="160" fill="#f4f2fd" stroke="#2a1659" strokeWidth="4" />
                        <rect x="60" y="68" rx="18" ry="18" width="140" height="100" fill="#160a33" stroke="#9b7bf0" strokeWidth="3" />
                        <g stroke="#b79bff" strokeWidth="6" strokeLinecap="round">
                            <line x1="130" y1="98" x2="130" y2="132" />
                            <line x1="130" y1="142" x2="130" y2="146" />
                        </g>
                        <polygon
                            points="130,92 158,140 102,140"
                            fill="none"
                            stroke="#b79bff"
                            strokeWidth="4"
                            strokeLinejoin="round"
                        />
                        <rect x="14" y="110" width="14" height="36" rx="6" fill="#e7e2fb" stroke="#2a1659" strokeWidth="3" />
                        <rect x="232" y="110" width="14" height="36" rx="6" fill="#e7e2fb" stroke="#2a1659" strokeWidth="3" />
                        <path d="M70 208 Q130 240 190 208 L190 270 Q130 300 70 270 Z" fill="#f4f2fd" stroke="#2a1659" strokeWidth="4" />
                        <path d="M115 215 Q130 235 145 215" fill="none" stroke="#9b7bf0" strokeWidth="3" />
                        <ellipse cx="70" cy="250" rx="20" ry="34" fill="#f4f2fd" stroke="#2a1659" strokeWidth="4" />
                        <ellipse cx="190" cy="250" rx="20" ry="34" fill="#f4f2fd" stroke="#2a1659" strokeWidth="4" />
                    </svg>
                </div>

                {/* ---- Texto ---- */}
                <div style={styles.copy}>
                    <div style={styles.code404} aria-hidden="true">
                        404
                    </div>
                    <h1 style={styles.title}>Ups, parece que esta página se perdió en el camino.</h1>
                    <p style={styles.subtitle}>El contenido que intentas visitar ya no existe o fue movido.</p>

                    <div style={styles.actions}>
                        <Link to="/" style={styles.primaryBtn}>
                            Volver al inicio
                        </Link>
                        <Link to="/soporte" style={styles.secondaryBtn}>
                            Contactar soporte
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

const styles = {
    page: {
        minHeight: "100vh",
        width: "100%",
        background: "linear-gradient(160deg, #2a1659 0%, #3d1f73 55%, #2a1659 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "32px",
        fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
        boxSizing: "border-box",
    },
    scene: {
        display: "flex",
        alignItems: "center",
        gap: "48px",
        maxWidth: "960px",
        width: "100%",
        flexWrap: "wrap",
        justifyContent: "center",
    },
    robotWrap: {
        flex: "0 0 auto",
        animation: "float 3.5s ease-in-out infinite",
    },
    robot: {
        display: "block",
    },
    copy: {
        flex: "1 1 360px",
        maxWidth: "480px",
        color: "#f4f2fd",
        textAlign: "left",
    },
    code404: {
        fontSize: "20px",
        fontWeight: 700,
        letterSpacing: "4px",
        color: "#b79bff",
        marginBottom: "8px",
    },
    title: {
        fontSize: "clamp(28px, 4vw, 38px)",
        fontWeight: 800,
        lineHeight: 1.25,
        margin: "0 0 16px",
        color: "#ffffff",
    },
    subtitle: {
        fontSize: "16px",
        color: "#cdbdf7",
        margin: "0 0 32px",
        lineHeight: 1.5,
    },
    actions: {
        display: "flex",
        gap: "16px",
        flexWrap: "wrap",
    },
    primaryBtn: {
        background: "#7c4dff",
        color: "#fff",
        padding: "12px 24px",
        borderRadius: "10px",
        fontWeight: 700,
        textDecoration: "none",
        fontSize: "15px",
        boxShadow: "0 8px 20px rgba(124,77,255,0.4)",
    },
    secondaryBtn: {
        background: "transparent",
        color: "#f4f2fd",
        padding: "12px 24px",
        borderRadius: "10px",
        fontWeight: 700,
        textDecoration: "none",
        fontSize: "15px",
        border: "2px solid #7c4dff",
    },
};
